import { PageDataHandler } from "@/lib/utility/data/page-data-handler";
import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IAiResult, AiResult } from "@/models/ai-result.entity";
import aiService from "@/services/mrfiktiv/services/aiService";
import { MrfiktivAiControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Module, getModule } from "vuex-module-decorators";
import { PaginatedBaseStore } from "../paginated-base.store";
import { AiResultDataAccessLayer } from "./access-layers/ai-result.access-layer";
import { PaginationFilterListElement } from "./base-pagination.store";

const AiResultPageDataProvider = new (class extends AbstractPageDataProvider<
  IAiResult,
  MrfiktivAiControllerGetParamsGen
> {
  itemsPerPage = 25;

  async getPage(query: MrfiktivAiControllerGetParamsGen): Promise<IPageViewModel<IAiResult>> {
    const res = await aiService.get(query);

    const meta = res.meta;
    const data = ((res.data ?? []) as IAiResult[]).map((d) => new AiResult(d));

    return { meta, data };
  }
})();

@Module({
  dynamic: true,
  namespaced: true,
  name: "aiResult",
  store
})
export class AiResultPaginationStore extends PaginatedBaseStore<IAiResult, MrfiktivAiControllerGetParamsGen> {
  protected _data = AiResultDataAccessLayer;
  protected _pageProvider = AiResultPageDataProvider;
  protected _pager = new PageDataHandler(this._data, this._pageProvider);

  filterOptions: PaginationFilterListElement[] = AiResult.filterables;
}

export const AiResultModule = getModule(AiResultPaginationStore);
